export default {
  slogan: 'Playturbo',
  loginToPt: '登录 Playturbo',
  loginPopbox: {
    title: '提示',
    content: '登录失败，请重新尝试',
    confirm: '确定',
  },
  form: {
    userPlaceHolder: '请输入用户名称',
    userRequiredText: '用户名称或邮箱不能为空',
    passwordPlaceHolder: '请输入密码',
    passwordRequiredText: '密码不能为空',
    verifyCodeRequiredText: '验证码不能为空',
    loginText: '登录',
    loginSuccessText: '登录成功！',
    forgetText: '忘记密码',
    registerText: '免费注册',
    privacyLabel: {
      readAgreed: '我已阅读、理解并同意接受',
      userAgreement: '用户服务协议',
      membershipAgreement: 'Playturbo会员服务协议',
      and: '及',
      privacyAgreement: '隐私协议',
      dpaTitle: '《数据保护附录》',
      dpaDesc:
        '我确认已获得上传这些语音样本的所有必要权利或同意，并保证不会将平台生成的内容用于任何非法、欺诈或有害的目的。',
    },
    privacyRequiredText: '请勾选保密隐私协议',
  },
  swiper: {
    psTitle: '可玩工具，零门槛轻松制作',
    videoTitle: '视频工具，批量生成作品基地',
    recordTitle: '录屏工具，助你解放双手',
    psLabel:
      '无需代码基础，轻松自制可玩广告<br/>多语言多渠道一键打包，广告投放更高效海量<br/>优质模板选择，打破行业创意壁垒',
    videoLabel:
      '海量商用资产库，满足所有设计效果<br/>元素片段批量组合，一键输出多条作品<br/>智能配音，快捷字幕适配，一站式完成快速制作',
    recordLabel:
      '参数自定义设置，关卡内容随心搭配<br/>一次录制操作，轻松输出多版本',
  },
  about: '关于',
  register: '注册',
}
